import styled, { css } from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";
import {JackpotWidgetFooterDefaultBox} from "./jackpot-widget-footer.default.box";

export const JackpotWidgetFooterMrGreenBox = styled(JackpotWidgetFooterDefaultBox)`
	${({layout}) => (layout === JACKPOT_WIDGET_LAYOUT.PORTRAIT) && css`
		min-height: inherit;
	`}
`;
